// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizedFunctionalUnitInput
 */
export interface OrganizedFunctionalUnitInput {
    /**
     * Browse path of the source FunctionalUnit (e.g. DeviceSet/FreezerDevice@0815/FunctionalUnitSet/FreezerUnit)
     */
    sourceBrowsePath: string;
    /**
     * Browse path of the target FunctionalUnitSet that will organize the source (e.g. DeviceSet/myViscometer@4711/FunctionalUnitSet)
     */
    targetBrowsePath: string;
}

/**
 * Check if a given object implements the OrganizedFunctionalUnitInput interface.
 */
export function instanceOfOrganizedFunctionalUnitInput(value: object): value is OrganizedFunctionalUnitInput {
    if (!('sourceBrowsePath' in value) || value['sourceBrowsePath'] === undefined) return false;
    if (!('targetBrowsePath' in value) || value['targetBrowsePath'] === undefined) return false;
    return true;
}

export function OrganizedFunctionalUnitInputFromJSON(json: any): OrganizedFunctionalUnitInput {
    return OrganizedFunctionalUnitInputFromJSONTyped(json, false);
}

export function OrganizedFunctionalUnitInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizedFunctionalUnitInput {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceBrowsePath': json['sourceBrowsePath'],
        'targetBrowsePath': json['targetBrowsePath'],
    };
}

export function OrganizedFunctionalUnitInputToJSON(json: any): OrganizedFunctionalUnitInput {
    return OrganizedFunctionalUnitInputToJSONTyped(json, false);
}

export function OrganizedFunctionalUnitInputToJSONTyped(value?: OrganizedFunctionalUnitInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceBrowsePath': value['sourceBrowsePath'],
        'targetBrowsePath': value['targetBrowsePath'],
    };
}

